import { useMemo } from 'react';
import { applyExcelFormats } from '../../../../utils/excel';
import { exportReportFile, processReport } from '../../../../utils/reports';
import { LOGINS_COLUMNS } from '../../../../constants/reports';
import ReportList from '../ReportList';
import ReportActionRow from '../ReportActionRow';

function ReportConsumerLogins({
  reportTitle,
  reportDetails,
  reportId,
  reportFileName,
  reportType,
  setSpinner,
  report,
}) {
  const { processedReport } = useMemo(
    () => processReport(reportType, report),
    [reportType, report],
  );

  const formattedReport = useMemo(() => {
    if (processedReport.length > 0) {
      return processedReport.map(r =>
        Object.entries(r).reduce(
          (acc, [key, value]) => ({
            ...acc,
            [key]:
              value !== null ? applyExcelFormats(value, LOGINS_COLUMNS[key]?.style?.numFmt) : null,
          }),
          {},
        ),
      );
    }

    return [];
  }, [processedReport]);

  return (
    <>
      <ReportActionRow
        reportTitle={reportTitle}
        reportDetails={reportDetails}
        reportId={reportId}
        setSpinner={setSpinner}
        exportFile={() => exportReportFile({ reportType, reportFileName, report })}
      />
      <ReportList
        report={formattedReport}
        tableColumns={LOGINS_COLUMNS}
        headerHeight={36}
        rowKey="uuid"
      />
    </>
  );
}

export default ReportConsumerLogins;
